'use strict';

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

module.exports = _isNaN;
